import { AuctionLot } from '@/staff/domain/exclusive/AuctionLot';
import { BackendBid, toBid } from '@/staff/secondary/exclusive/BackendBid';
import { BackendPrice, toTokens } from '@/common/secondary/token/BackendPrice';
import { Optional } from '@/common/domain/Optional';
import { BackendAuction, toAuction } from '@/staff/secondary/exclusive/BackendAuction';

export interface BackendAuctionLot {
  startingPrice: BackendPrice;
  currentPrice: BackendPrice;
  auction: BackendAuction;
  number?: number;
  bids: BackendBid[];
}

export const toAuctionLot = (backendAuction: BackendAuctionLot): AuctionLot => ({
  startingPrice: toTokens(backendAuction.startingPrice),
  currentPrice: toTokens(backendAuction.currentPrice),
  auction: toAuction(backendAuction.auction),
  number: Optional.ofUndefinable(backendAuction.number),
  bids: backendAuction.bids.map(toBid),
});
